
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/Sidebar.vue";
import Cta from "@/components/buttons/Button.vue";
import Tag from "@/components/tags/Tag.vue";
import Tabs from "@/components/tabs/Tab.vue";
import Modal from "@/components/modal/Modal.vue";
import { login, toast } from "@/store";
import { User } from "@/models";
import LoginService from "@/services/login.service";
import { LocalStorageApp } from "@/utils/localstorage";
import { getPasswordStrengthErrors } from "@/helpers";

@Component({
  components: {
    Sidebar,
    Cta,
    Tag,
    Tabs,
    Modal,
  },
})
/** Current user's profile page — identity, competences, habilitations, and password change. */
export default class Profile extends Vue {
  private tabSelected = "profil";
  private tabs = [
    { key: "profil", label: "Profil" },
    { key: "competences", label: "Compétences" },
    { key: "habilitations", label: "Habilitations" },
  ];

  private modalUpdatePasswd = false;
  private passwdActuel = "";
  private passwdNew = "";
  private passwdNewConfirm = "";

  private openUpdatePasswd(): void {
    this.modalUpdatePasswd = true;
  }
  private closeUpdatePasswd(): void {
    this.modalUpdatePasswd = false;
    this.passwdActuel = "";
    this.passwdNew = "";
    this.passwdNewConfirm = "";
  }
  /**
   * Validates and submits the password-change form: all fields filled, new password matches its
   * confirmation, differs from the current one, and meets the org's strength policy (see
   * `PASSWORD_REQUIREMENTS` in `helpers/password.helpers.ts`).
   */
  private async validUpdatePasswd(): Promise<void> {
    if (this.passwdActuel && this.passwdNew && this.passwdNewConfirm) {
      if (this.passwdNew === this.passwdNewConfirm) {
        if (this.passwdActuel !== this.passwdNew) {
          const strengthErrors = getPasswordStrengthErrors(this.passwdNew);
          if (strengthErrors.length === 0) {
            if (
              await LoginService.changePassword(
                this.passwdActuel,
                this.passwdNew,
                this.passwdNewConfirm
              )
            ) {
              LocalStorageApp.setItem("pcp.mustChangePassword", false);
              this.closeUpdatePasswd();
            }
          } else {
            toast.pushError(
              `Votre nouveau mot de passe ne respecte pas les règles suivantes : ${strengthErrors.join(
                ", "
              )}`
            );
          }
        } else {
          toast.pushError(
            "Votre nouveau mot de passe doit être différent de celui actuel"
          );
        }
      } else {
        toast.pushError(
          "Votre nouveau mot de passe n'est pas identique à la confirmation"
        );
      }
    } else {
      toast.pushError("Merci de remplir l'ensemble des champs");
    }
  }

  get context(): User | null {
    return login.getContext;
  }
}
